import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=b3cf375c&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=b3cf375c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cf375c",
  null
  
)

export default component.exports